import { PiniaColada } from "@pinia/colada";
import {
  emitComponentLoaded,
  initEmitIframeResize,
  initOnArgusSession,
  initVueIslands,
  type VueIslandConfig,
} from "@solvari/common-fe/helpers";
import { initFontAwesome } from "@solvari/common-fe/integrations";
import { createPinia } from "pinia";

import { initPrimeVue } from "@solvari/components";

import "@/partner/utils/sentry";
import "@solvari/common-fe/polyfills";

import "@/shared/tailwind.css";

function main() {
  initEmitIframeResize();
  initOnArgusSession();
  emitComponentLoaded("document");
  initFontAwesome();

  const components = {
    leadForm: () => import("@/partner/pages/forms-iframe/leadForm.ts"),
  } satisfies VueIslandConfig;

  const pinia = createPinia();
  initVueIslands(components, (app) => {
    app.use(pinia);
    app.use(PiniaColada, {});
    initPrimeVue(app);
  });
}

main();
